export const emailIpWarmingAppGroupIdPlans = "/email/ip_warming/:app_group_id/plans";
